module.exports = __webpack_public_path__ + "img/user-ico.0a1718b6.svg";